import React, { useState, useEffect, useContext } from "react";

import { Paper } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useStyles } from "./style";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import {
  EnhancedTableToolbar,
  CardItem,
} from "../../../components/pages/reports/proformaReport/index";

// ✅ CHANGE CONTEXT
import { ProformaReportContext } from "../../../context/states/reports/proformaReportState";

const initialState = {
  isSearch: false,
  companyId: "",
  company: "",
  fromDate: null,
  toDate: null,
  businessType: "",
};

const ProformaReport = () => {
  const classes = useStyles();
  const matches = useMediaQuery("(min-width:1920px)");

  const {
    proformas,
    totalAmount,
    clients,
    totalVat,
    count,
    loading,
    getClientsHandler,
    getProformaReportHandler,
    clearProformaStateHandler,
  } = useContext(ProformaReportContext);

  const [values, setValues] = useState({ ...initialState });
  const [dense] = useState(true);

  useEffect(() => {
    getProformaReportHandler("");
  }, []);

  // ✅ Handle Inputs
  const handleChange = (event) => {
    const { name, checked, value, type } = event.target;

    setValues((prev) => ({
      ...prev,
      [name]:
        name === "businessType"
          ? checked
            ? "Private"
            : ""
          : type === "checkbox"
            ? checked
            : value,
    }));
  };

  const handleChangeAutoComplete = (name) => (event, value) => {
    if (value === null) {
      setValues({ ...initialState });
      clearProformaStateHandler();
      return;
    }
    if (name === "company") {
      setValues({ ...values, [name]: value, companyId: value._id });
    }
  };

  const handleInputChange = (event) => {
    if (event.target.value === "") return;
    getClientsHandler(event.target.value);
  };

  const handleFromDateChange = (event) => {
    const date = new Date(event).toISOString();
    setValues({ ...values, fromDate: date });
  };

  const handleToDateChange = (event) => {
    const date = new Date(event).toISOString();
    setValues({ ...values, toDate: date });
  };

  // ✅ SEARCH
  const searchHandler = () => {
    let query = "";

    if (values.companyId !== "") {
      query += `companyId=${values.companyId}`;
    }

    if (values.businessType !== "") {
      query += `${query.length > 0 ? "&" : ""}businessType=${values.businessType}`;
    }

    let filteredDate = "";

    if (values.fromDate) {
      filteredDate = `&fromDate=${values.fromDate}`;
      if (values.toDate) {
        filteredDate += `&toDate=${values.toDate}`;
      }
    }

    getProformaReportHandler(`${query}${filteredDate}`);
  };

  const clearSearchHandler = () => {
    setValues({ ...initialState });
    getProformaReportHandler("");
  };

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        <Paper className={classes.paper}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <EnhancedTableToolbar
              handleChange={handleChange}
              values={values}
              isClients={clients}
              handleInputChange={handleInputChange}
              handleChangeAutoComplete={handleChangeAutoComplete}
              // ✅ UPDATED TOTALS
              count={count}
              totalAmount={totalAmount}
              totalVat={totalVat}
              title={"Proforma Report"}
              handleFromDateChange={handleFromDateChange}
              handleToDateChange={handleToDateChange}
              searchHandler={searchHandler}
              clearSearchHandler={clearSearchHandler}
            />
          </MuiPickersUtilsProvider>

          <CardItem
            title="Proforma Report"
            active={classes.paidStage}
            classes={classes}
            isLoading={loading}
            data={proformas}
            dense={dense}
            matches={matches}
            values={values}
            hasData={proformas && proformas.length > 0}
          />
        </Paper>
      </div>
    </React.Fragment>
  );
};

export default ProformaReport;
